import { api } from "../libs/apis/api";
import { settings } from "../const/Settings";
import { DateUtils } from "../libs/utils/DateUtils";
import { DataUtils } from "../libs/utils/DataUtils";
import { isLocalDevelopment } from "socios-tools/const/sociosSettings";
import * as dayjs from "dayjs";
export class MediaModel {
    constructor(rawData) {
        this.getImage = (size) => {
            const image = DataUtils.imageLookup(this._rawData.image, size);
            return image ? image.url : this._rawData.image_url || '';
        };
        this.getMediaItemTitle = () => {
            return this.getTitle(60);
        };
        this._rawData = rawData;
        if (rawData.chronological) {
            this._chronologicalDate = dayjs(rawData.chronological).toDate();
        }
    }
    get id() {
        return this._rawData.id || '';
    }
    getRawData() {
        return this._rawData;
    }
    get url() {
        return this._rawData.url || '';
    }
    notComplete() {
        if (!this._rawData) {
            return 'any data';
        }
        else if (!this._rawData.id) {
            return 'id';
        }
        else if (!this._rawData.url) {
            return 'url';
        }
        else if (!this._rawData.title) {
            return 'title';
        }
        else if (!this._rawData.type) {
            return 'type';
        }
        else if (!this._rawData.chronological) {
            return 'chronological';
        }
        else if (!this._rawData.params) {
            return 'params';
        }
        else if (!this._rawData.meta) {
            return 'meta';
        }
        else if (!this._rawData.meta.tags) {
            return 'meta.tags';
        }
        else if (!this._rawData.params.ref) {
            return 'params.ref';
        }
        else if (!this._rawData.params.url) {
            return 'params.url';
        }
        return '';
    }
    get title() {
        return this._rawData.title || '';
    }
    getTitle(truncateAt = -1) {
        let title = this.title;
        if (truncateAt > -1 && title.length > truncateAt) {
            const ellipsis = '...';
            title = title.substring(0, (truncateAt - ellipsis.length)) + ellipsis;
        }
        return title;
    }
    getArticleTitle() {
        return this.getTitle(80);
    }
    get bodyHtml() {
        const body = this._rawData.body;
        if (body) {
            return body;
        }
        else {
            const articleTitle = this.getArticleTitle();
            if (articleTitle !== this.title) {
                return this.title;
            }
        }
        return '';
    }
    get tags() {
        if (this._rawData.meta && this._rawData.meta.tags) {
            return this._rawData.meta.tags;
        }
        else {
            return [];
        }
    }
    get linkDump() {
        return this._rawData.meta.link_dump ? this._rawData.meta.link_dump : null;
    }
    get tagTitles() {
        return this.tags.map(tag => tag.title);
    }
    get advertisingTargeting() {
        if (this._rawData.meta && this._rawData.meta.advertising_targeting) {
            return this._rawData.meta.advertising_targeting;
        }
        else {
            return [];
        }
    }
    get type() {
        if (isLocalDevelopment && settings.dVideo.enabled) {
            return settings.dVideo.type;
        }
        return this._rawData.type || '';
    }
    get params() {
        if (isLocalDevelopment && settings.dVideo.enabled) {
            return settings.dVideo.params;
        }
        return this._rawData.params || { ref: '', url: '' };
    }
    get metaTitle() {
        if (this._rawData.meta && this._rawData.meta.source) {
            return this._rawData.meta.source.title || '';
        }
        else {
            return '';
        }
    }
    isLinkDump() {
        return this._rawData.meta ? DataUtils.isNotNone(this._rawData.meta.link_dump) : false;
    }
    get metaUrl() {
        if (this._rawData.meta && this._rawData.meta.source) {
            return this._rawData.meta.source.url || '';
        }
        else {
            return '';
        }
    }
    get relatedApiUrl() {
        return this._rawData.related || '';
    }
    get useBluebillywig() {
        return this._rawData.use_bluebillywig;
    }
    get endedSuggestionsApiUrl() {
        return this._rawData.ended_suggestions || '';
    }
    get chronologicalDateISO() {
        return this._rawData.chronological;
    }
    get chronologicalDateString() {
        return this._chronologicalDate ? DateUtils.parseDateFormat('[date] [locMonth] [fullYear], [locHours]:[locMinutes] uur', this._chronologicalDate) : '';
    }
    static fetch(topicID) {
        return api.get(settings.apiVideoPath + topicID + '/', null, { allowCache: true }).then((result) => {
            return new MediaModel(result.body);
        });
    }
}
